export const SAVE_PAYMENT_METHOD = 'save-payment-method';

export default function savePaymentMethod({ id, nonce, label, isUpdate }) {
  return {
    type: SAVE_PAYMENT_METHOD,
    payload: {
      id,
      nonce,
      label,
      isUpdate,
    },
  };
}
